/* @ngInject */
function SharedPacksItemsController ($scope, $timeout, $attrs) {
  /** @type {IntersectionObserver | null} */
  let intersectionObserver = null

  $scope.hasShowMoreButton = false

  const emptyTitleKeys = {
    ACTIVE: 'sharedPacks.emptyActiveTitle',
    EXPIRED: 'sharedPacks.emptyExpiredTitle',
    SEARCH: $scope.selectedTab === 'active' ? 'sharedPacks.emptySearchTitleActive' : 'sharedPacks.emptySearchTitleExpired'
  }

  const emptyMessageKeys = {
    ACTIVE: 'sharedPacks.emptyActiveMessage',
    EXPIRED: 'sharedPacks.emptyExpiredMessage',
    SEARCH: 'sharedPacks.emptySearchMessage'
  }

  const api = {
    _setEmptyKeys,
    _initObserverShowMore,
    _disconnectObserver,
    _verifyIntersectionButton,
    _getShowMore,
    _updateHasShowMoreButtonStateAndInitObserver
  }

  this.getApi = () => api

  function activate () {
    api._setEmptyKeys()
  }

  activate()

  function _setEmptyKeys () {
    $scope.emptyTitleKey = emptyTitleKeys[$scope.viewMode]
    $scope.emptyMessageKey = emptyMessageKeys[$scope.viewMode]
  }

  function _initObserverShowMore () {
    const showMoreButton = $attrs.$$element.find('.button-load-more')

    api._disconnectObserver()

    if (!showMoreButton[0]) {
      return
    }

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.4
    }

    intersectionObserver = new IntersectionObserver(api._verifyIntersectionButton, options)
    intersectionObserver.observe(showMoreButton[0])
  }

  function _disconnectObserver () {
    if (intersectionObserver) {
      intersectionObserver.disconnect()
    }
  }

  function _verifyIntersectionButton ([entry]) {
    if (entry.isIntersecting && entry.intersectionRatio >= 0.4 && $scope.hasShowMoreButton) {
      $timeout(() => {
        api._getShowMore()
      }, 0, true)
    }
  }

  function _getShowMore () {
    if (!$scope.loadingMore) {
      $scope.onLoadMore()
    }
  }

  function _updateHasShowMoreButtonStateAndInitObserver () {
    const previousHasShowMoreButton = $scope.hasShowMoreButton
    $scope.hasShowMoreButton = $scope.count > $scope.items.length

    if (!previousHasShowMoreButton && $scope.hasShowMoreButton) {
      $timeout(() => {
        api._initObserverShowMore()
      }, 500)
    }
  }

  $scope.handleOnChangeSort = (columnName) => {
    $scope.onChangeSort({ $event: columnName })
  }

  $scope.handleOnItemUpdate = () => {
    $scope.onItemUpdate()
  }

  $scope.scrollShowMore = api._getShowMore

  $scope.$watchCollection('items', (newItemsList) => {
    if (newItemsList?.length) {
      api._updateHasShowMoreButtonStateAndInitObserver()
    } else {
      $scope.hasShowMoreButton = false
      api._disconnectObserver()
    }
  })

  $scope.$on('$destroy', () => {
    api._disconnectObserver()
  })
}

export { SharedPacksItemsController }
